import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ShopContext } from '../Context/ShopContext';
import Breadcrum from '../Components/Breadcrums/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';

const Product = () => {
    const { all_Product } = useContext(ShopContext);
    const { productId } = useParams();
    const product = all_Product.find((e) => e.id === Number(productId));

    // This "gatekeeper" check is perfect.
    if (!product) {
        return <div>Loading Product...</div>; // Changed to a loading message
    }

    return (
        <div>
            <Breadcrum product={product} />
            <ProductDisplay product={product} />
            
            {/* --- THIS IS THE CORRECTED LINE --- */}
            <DescriptionBox productId={product.id} />
            
            <RelatedProducts 
                brand={product.brand} 
                category={product.category} 
                type={product.type} 
            />
        </div>
    );
}

export default Product;